/**
 * Hands the semantic theme to components (DESIGN_SYSTEM.md §3.4).
 *
 * The context's default IS the POS theme, so neither app mounts a provider and an isolated render (a
 * test, a node renderer) still gets a complete theme, as `useKioskTheme()` does. `ThemeProvider` is
 * for the themes that come later, each its own decision (the kiosk's, a dark one).
 */
import React, { createContext, useContext } from "react";

import { posTheme } from "./theme";
import type { Theme } from "./theme";

const ThemeContext = createContext<Theme>(posTheme);

export function ThemeProvider({ theme, children }: { theme: Theme; children: React.ReactNode }) {
  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
}

export function useTheme(): Theme {
  return useContext(ThemeContext);
}

export type { Theme };
